module.exports = __webpack_public_path__ + "static/intesso-f9930420456379dc5a599f105650753b.png";